import PropTypes from "prop-types";
import { Box, useMediaQuery } from "@mui/material";
import { styled } from "@mui/material/styles";
import { MobileNav } from "../mobile-nav";
import { TopNav } from "./top-nav";
import { useMobileNav } from "./use-mobile-nav";
import { useLocation } from "react-router-dom";
import { NoticeProvider } from "src/components/notice-provider";
import { TOP_NAV_HEIGHT, TOP_MENU_HEIGHT } from "./top-nav";

const HorizontalLayoutRoot = styled("div")(({ topHeight }) => ({
  display: "flex",
  flex: "1 1 auto",
  maxWidth: "100%",
  height: `calc(100vh - ${topHeight}px)`,
  minHeight: 0, // ✅ 추가
  minWidth: 0, // ✅ 추가 (가끔 가로도 필요)
}));

const MobileHorizontalLayoutRoot = styled("div")(({ topHeight }) => ({
  display: "flex",
  flex: "1 1 auto",
  maxWidth: "100%",
  height: `calc(100vh - ${topHeight}px)`,
  minHeight: 0, // ✅ 추가
  minWidth: 0, // ✅ 추가 (가끔 가로도 필요)
}));

const HorizontalLayoutContainer = styled("div")({
  display: "flex",
  flex: "1 1 auto",
  flexDirection: "column",
  width: "100%",
  height: "100%",
  minHeight: 0, // ✅ 추가
  minWidth: 0, // ✅ 추가 (가끔 가로도 필요)
});

export const HorizontalLayout = (props) => {
  const { children, navColor, sections, forceMenu = false } = props;
  const mdUp = useMediaQuery((theme) => theme.breakpoints.up("desktop"));
  const mobileNav = useMobileNav();

  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const menuParam = query.get("menu");
  const topVisible = forceMenu || menuParam !== "false"; // 없거나 true면 true, false면 false

  const topHeight = topVisible ? TOP_NAV_HEIGHT + TOP_MENU_HEIGHT : 0;
  const mobileTopHeight = topVisible ? TOP_NAV_HEIGHT : 0;

  return (
    <>
      <TopNav
        color={navColor}
        onMobileNav={mobileNav.handleOpen}
        sections={sections}
        visible={topVisible}
      />
      {!mdUp && (
        <>
          <MobileNav
            color={navColor}
            onClose={mobileNav.handleClose}
            open={mobileNav.open}
            sections={sections}
          />
          <MobileHorizontalLayoutRoot topHeight={mobileTopHeight}>
            <NoticeProvider>
              <HorizontalLayoutContainer>
                <Box sx={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0, minWidth: 0 }}>{children}</Box>
              </HorizontalLayoutContainer>
            </NoticeProvider>
          </MobileHorizontalLayoutRoot>
        </>
      )}
      {mdUp && (
        <HorizontalLayoutRoot topHeight={topHeight}>
          <NoticeProvider>
            <HorizontalLayoutContainer>
              <Box sx={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0, minWidth: 0 }}>{children}</Box>
            </HorizontalLayoutContainer>
          </NoticeProvider>
        </HorizontalLayoutRoot>
      )}
    </>
  );
};

HorizontalLayout.propTypes = {
  children: PropTypes.node,
  forceMenu: PropTypes.bool,
  navColor: PropTypes.oneOf(["blend-in", "discreet", "evident"]),
  sections: PropTypes.array,
};
